// Utility to build filter payloads and query strings from FilterBar state
export function getDateRange(period, customStart, customEnd) {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  const fmt = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

  if (period === 'today') { const t = fmt(now); return { start: t, end: t }; }
  if (period === 'this_week') {
    const day = now.getDay();
    const monday = new Date(now);
    monday.setDate(now.getDate() - (day === 0 ? 6 : day - 1));
    return { start: fmt(monday), end: fmt(now) };
  }
  if (period === 'this_month') return { start: fmt(new Date(now.getFullYear(), now.getMonth(), 1)), end: fmt(now) };
  if (period === 'this_year') return { start: fmt(new Date(now.getFullYear(), 0, 1)), end: fmt(now) };
  if (period === 'custom') return { start: customStart || null, end: customEnd || null };
  return { start: null, end: null };
}

export function buildFiltersFromState(state = {}) {
  const { timePeriod, customStart, customEnd, venue, event, productType } = state;
  const { start, end } = getDateRange(timePeriod, customStart, customEnd);

  // don't emit custom until both dates are present
  if (timePeriod === 'custom' && (!start || !end)) {
    return null;
  }

  const params = new URLSearchParams();
  if (start) params.set('start', start);
  if (end) params.set('end', end);
  if (venue && venue !== 'all') params.set('venueId', String(venue));
  if (event && event !== 'all') params.set('eventId', String(event));
  if (productType && productType !== 'all') params.set('productType', productType);

  return {
    timePeriod,
    venue: venue || 'all',
    event: event || 'all',
    productType: productType || 'all',
    start: start || null,
    end: end || null,
    queryString: params.toString(),
  };
}
